import { Identifier } from "../../core";
export class ScheduleId extends Identifier {
    constructor(id) {
        super("ScheduleId", id);
    }
}
